export default defineNuxtRouteMiddleware((to) => {
  if (to.path === '/search' && !to.query.q) {
    return navigateTo('/')
  }
})
